import _ from 'lodash'
import { getActive } from 'shared-js/menu-services/active-items-util'

export function getOffers (menuBlob) {
  return _.get(menuBlob, 'offers', [])
}

export function getActiveOffers (menuBlob) {
  return getActive(getOffers(menuBlob))
}

export function getOffer (offerId, menuBlob) {
  return getOffers(menuBlob).find(it => it.id === offerId)
}
